// @flow

import React from 'react';
import Group from './group.styled';

export default (props: any) => (
  <Group
    {...props}
    data-cy="cartGroup"
  />
);
